// glyphs.js 
// HTML codes for glyphs of planets and signs
export const pGlyph = [
    "&#33;", // 0 Sun
    "&#34;", // 1 Moon
    "&#35;", // 2 Mercury
    "&#36;", // 3 Venus
    "&#37;", // 4 Mars
    "&#38;", // 5 Jupiter
    "&#39;", // 6 Saturn
    "&#40;", // 7 Uranus
    "&#41;", // 8 Neptune
    "&#42;", // 9 Pluto
    "&#43;", // 10 North Node
    "&#45;", // 11 Ascendant
    "&#46;", // 12 Midhemel
    "&#00;", // 13 Chiron
    "&#124;", // 14 Pars Fortuna
  ];
  
  export const sGlyph = [
    "&#80;", // 0 Aries
    "&#81;", // 1 Taurus
    "&#82;", // 2 Gemini
    "&#83;", // 3 Cancer
    "&#84;", // 4 Leo
    "&#85;", // 5 Virgo
    "&#86;", // 6 Libra
    "&#87;", // 7 Scorpio
    "&#88;", // 8 Sagittarius
    "&#89;", // 9 Capricorn
    "&#90;", // 10 Aquarius
    "&#91;", // 11 Pisces
  ];
  
  export const aGlyph = [
    { deg:0, glyph: "&#93;" }, // 0 conjunctie
    { deg:180, glyph: "&#94;" }, // 1 oppositie
    { deg:90, glyph: "&#96;" }, // 2 vierkant
    { deg:45, glyph: "&#98;" }, // 3 halfvierkant
    { deg:135, glyph: "&#99;" }, // 4 anderhalfvierkant
    { deg:120, glyph: "&#95;" }, // 5 driehoek
    { deg:60, glyph: "&#97;" }, // 6 sextiel
    { deg:150, glyph: "&#100;" }, // 7 inconjunct
  ];